var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.video && _vm.videoNim)?_c('div',[_c('MediaPlayer',{attrs:{"cover":_vm.video.cover,"origUrl":_vm.videoNim.origUrl,"pauseTime":_vm.pauseTime},on:{"beforeDestroy":_vm.handleBeforeDestroyed,"play":_vm.handlePlay,"pause":_vm.handlePause,"ended":_vm.handleEnded}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }